

export const VERSION_CONFIG = {
  // BUILD_NO : ,
  RELEASE_NO : '2.1.0',
};



/**
 * 
 * - 2.1.0
 * 업데이트:
 *  AI리포트 기능 추가
 *  일자별 빅데이터 조회에 AI 기능 추가
 *  병실별 빅데이터 조회에 AI 기능 추가
 */


/**
 * 
 * - 2.0.1
 * 업데이트:
    이번주 AI브리핑 카드 추가
    전체적인 대시보드 디자인 개선
 */

/**
 * 
 * - 1.2.3
 * 업데이트:
    긴급/주의 푸시메시지 발송 유무
    요양사 알람수신시각 콤포넌트 변경
 */


/**
 * 
 * - 1.2.2
 * 업데이트:
    긴급/주의 이력 조회 버그 수정
 */


/**
 * 
 * - 1.2.1
 * 업데이트:
    긴급/주의 이력 조회
    기상/재실 이력 조회
 */


/*

- 1.0.6
  요양사 비밀번호 추가

- 1.0.5
  디바이스 점검 기능 개선

- 1.0.4
  '낙상' 자동복구 기능 추가
  센서 설정화면에서, 자동복구 ON/OFF 설정 기능 추가

- 1.0.3
 '긴급/주의 이력조회' 검색 일자->일시 변경, 각 칼럼 정령 기능 추가


 -1.0.8
  디바이스 점검 테이블 표시 runtime variation
  낙상 강제 자동복구


 -1.0.9
  대쉬보드 긴급 테이블 높이 조절
  각 센서 상태 디자인 변경
  각 센서 긴급 발생시, 배경색 변경

 -1.1.0
  긴급/주의 이력조회화면에 병실 선택 기능 추가

 -1.1.1
  Dashboard 각 방 상태 디자인 미세조정

- 1.1.2
  센서 상태 조회 기능 추가

- 1.1.3
  긴급 센서 디자인변경
  긴급조치하기 화면에서 '낙상 발생 위치 표시'

- 1.1.4
  다국어 지원

- 1.1.5
  센서 정보에 감지 영역 인터페이스 추가

- 1.1.6.
  센서 정보에 기상 영역 인터페이스 추가
  센서 정보에 침대 영역 인터페이스 추가
  기상 알람 기능 추가
  기상 및 낙상 알람 재생 중지 기능 추가
  기상 및 알람 재생 음악 변경
  기상 cardview 음영 처리


- 1.1.7
  센서 히트맵 추가

- 1.1.8
  기상, 재실 이력 조회 기능 추가

- 1.1.9
  앱 계정에 수면 모니터링 기능 추가

- 1.2.0
  앱 계정 수면분석 기능 강화
  - 앱 계정에서 수면분석용 센서 동적 선택토록
  - 수면분석용 센서 선택 다이어로그 추가
  - 수면분석용 센서 입력 폼 추가
  - 센서검색 폼 업데이트

*/

